<script>
import PaxTotalsBase from './paxTotalsBase.vue'
export default {
  page() {
    return {
      title: 'Tour Operator Report',
      meta: [
        {
          name: 'description',
          content: ``,
        },
      ],
    }
  },
  components: { PaxTotalsBase },
  data() {
    return {
      routeKey: 'alltourop',
      key1: 'TotalCkd',
      key2: 'TourOperator',
      key2Plural: 'Tour Operators',
      sortKey: 'value',
    }
  },
}
</script>

<template>
  <PaxTotalsBase
    :route-key="routeKey"
    :key1="key1"
    :key2="key2"
    :key2plural="key2Plural"
    :sort-key="sortKey"
  />
</template>
